import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { currentcartdetail } from '../../models/dashboard/cart/mywallet.currentcart.Modal';
import { AgentDetails, BeneficiaryDetails, PickupType, SendMoneyDetail, SendMoneyProgramDetail, StoreDetails, OldOrderData } from '../../models/sendmoney/sendmoney';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { SpanishCharConverstion } from '../../sharedcomponents/commonservice/SpanishTextHandling.service';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { Ng2DeviceService } from 'ng2-device-detector';
import { TranslateService } from 'ng2-translate/ng2-translate';
//import { Console } from 'console';
@Injectable()
export class SendMoneyService {
  private userGioLocation: UserGioLocation;
  private subModalPopup: ReplaySubject<any> = new ReplaySubject<any>(1);
  private subPageFlow = new ReplaySubject<any>(1);
  private subRepeatOrderFlow = new ReplaySubject<any>(1);
  private sendMoneyDetailData = new ReplaySubject<SendMoneyDetail>(1);
  private subjectBeneficiaryData = new ReplaySubject<BeneficiaryDetails>(1);

  private subcurrentcartdetail = new ReplaySubject<currentcartdetail>(1);
  //Store
  private storeDetailData = new ReplaySubject<StoreDetails>(1);

  private sendMoneyProgramDetailData = new ReplaySubject<SendMoneyProgramDetail>(1);
  private DeactivateSummaryFlag = new ReplaySubject<boolean>(1);
  private oldOrderData = new ReplaySubject<OldOrderData>(1);
  // constructor(private utilserv: utilityService) {
  constructor(
    private utilserv: utilityService,
    private geoloc: geolocation,
    private deviceService: Ng2DeviceService,
    private spanishConvert: SpanishCharConverstion,
    private translate: TranslateService
  ) {}
  resetAllData() {
    // if (this.sendMoneyDetailData != undefined) {
    //   this.sendMoneyDetailData.unsubscribe();
    // }
    // if (this.sendMoneyDetailData != undefined) {
    //   this.sendMoneyProgramDetailData.unsubscribe();
    // }

    let x = new SendMoneyDetail();
    let y = new SendMoneyProgramDetail();
    this.setSendMoneyDetailDataBlank(x);
    this.setSendMoneyProgramDetailData(y);

    // this.subPageFlow.unsubscribe();
  }
  isFirstTime() {
    const obj: any = this.subModalPopup;
    return obj._events.length === 0;
  }

  setRepeatOrderFlow(dataValue: string) {
    this.subRepeatOrderFlow.next({ Value: dataValue });
  }
  getRepeatOrderFlow() {
    return this.subRepeatOrderFlow.asObservable().share();
  }

  setPageFlow(dataValue: string) {
    this.subPageFlow.next({ Value: dataValue });
  }
  getPageFlow() {
    return this.subPageFlow.asObservable().share();
  }

  setModalPopup(dataValue: number, isLoad: boolean = false) {
    this.subModalPopup.next({ data: dataValue, isLoad: isLoad });
  }

  getModalPopup() {
    return this.subModalPopup.asObservable().share();
  }

  setSendMoneyDetailDataBlank(dataValues: SendMoneyDetail) {
    if (this.sendMoneyDetailData.isStopped == false) {
      this.sendMoneyDetailData.next(dataValues);
    }
  }
  setSendMoneyDetailData(dataValues: SendMoneyDetail) {
    dataValues.isData = true;
    this.sendMoneyDetailData.next(dataValues);
  }

  getSendMoneyDetailData(): Observable<any> {
    return this.sendMoneyDetailData.asObservable().share();
  }

  // this object for repeatorder flow
  setRepeatorderDetailData(dataValues: SendMoneyDetail) {
    dataValues.isData = true;
    this.sendMoneyDetailData.next(dataValues);
  }

  getRepeatorderDetailData(): Observable<any> {
    return this.sendMoneyDetailData.asObservable().share();
  }

  setcurrentcartDetailData(dataValues: currentcartdetail) {
    this.subcurrentcartdetail.next(dataValues);
  }

  getcurrentcartDetailData(): Observable<any> {
    return this.subcurrentcartdetail.asObservable().share();
  }

  setBeneficiaryData(dataValues: BeneficiaryDetails) {
    this.subjectBeneficiaryData.next(dataValues);
  }

  ///Store Data
  setStoreDetailData(dataValues: StoreDetails) {
    this.storeDetailData.next(dataValues);
  }

  getStoreDetailData(): Observable<any> {
    return this.storeDetailData.asObservable().share();
  }

  getBeneficiaryData(): Observable<any> {
    return this.subjectBeneficiaryData
      .asObservable()
      .share()
      .share();
  }

  getFilterBySortByData() {
    return this.utilserv.restGet(AppSettings.ICEMasterService + '/GetFilterBySortBy', true).share();
  }

  setSendMoneyProgramDetailData(dataValues: SendMoneyProgramDetail) {
    if (this.sendMoneyProgramDetailData.isStopped == false) {
      this.sendMoneyProgramDetailData.next(dataValues);
    }
  }

  getSendMoneyProgramDetailData(): Observable<any> {
    return this.sendMoneyProgramDetailData.asObservable().share();
  }

  setDeactivateSummaryFlag(dataValues: boolean) {
    this.DeactivateSummaryFlag.next(dataValues);
  }

  getDeactivateSummaryFlag(): Observable<boolean> {
    return this.DeactivateSummaryFlag.asObservable().share();
  }

  setRepeatorderOldData(dataValues: OldOrderData) {
     this.oldOrderData.next(dataValues);
  }

  getRepeatorderOldData(): Observable<any> {
    return this.oldOrderData.asObservable().share();
  }

  searchPayerDetails(searchParams: any, userGioLocation) {
    let serviceUrl = '';
    if (searchParams.DeliveryMethod == PickupType.officePickup || searchParams.DeliveryMethod == PickupType.homeDelivery || searchParams.DeliveryMethod == PickupType.atmDeposit) {
      serviceUrl = AppSettings.AgentManagementService + '/GetAgentsT2Based';
    } else if (searchParams.DeliveryMethod == PickupType.bankDeposit) {
      serviceUrl = AppSettings.AgentManagementService + '/GetBanksT2Based';
    }

    return this.utilserv.restPost(this.prepareEnvelopePayerDetails(searchParams, userGioLocation), serviceUrl);
  }

  initUserBeneficiaryDataFromSendmoneyObject(sendMoneyDetail: SendMoneyDetail, pagesrc: string = 'paymenttype') {
    let model: any = {};
    const validation = pagesrc == 'summary' ? sendMoneyDetail.branchDetails.SummaryValidation : sendMoneyDetail.branchDetails.Validation;
    const obj = sendMoneyDetail;
    model.userUserID = this.utilserv.getObjectText(obj.userDetails.UserID);
    model.isuserUserID = model.userUserID.length <= 0 ? true : false;
    model.userDOB = this.utilserv.getObjectText(obj.userDetails.dob);
    model.isuserDOB = model.userDOB.length <= 0 ? true : false;
    model.useradditionalLastName = this.utilserv.getObjectText(obj.userDetails.additionalLastName);
    model.isuseradditionalLastName = model.useradditionalLastName.length <= 0 ? true : false;
    model.userfirstName = this.utilserv.getObjectText(obj.userDetails.firstName);
    model.isuserfirstName = model.userfirstName.length <= 0 ? true : false;
    model.usermiddleName = this.utilserv.getObjectText(obj.userDetails.middleName);
    model.isusermiddleName = model.usermiddleName.length <= 0 ? true : false;
    model.userlastName = this.utilserv.getObjectText(obj.userDetails.lastName);
    model.isuserlastName = model.userlastName.length <= 0 ? true : false;
    model.usermobile = this.utilserv.getObjectText(obj.userDetails.mobile);
    model.isusermobile = model.usermobile.length <= 0 ? true : false;
    model.userCountry = this.utilserv.getObjectText(obj.userDetails.country);
    model.isuserCountry = model.userCountry.length <= 0 ? true : false;
    model.usercountryPreference = this.utilserv.getObjectText(obj.userDetails.countryPreference);
    model.isusercountryPreference = model.usercountryPreference.length <= 0 ? true : false;
    model.userState = this.utilserv.getObjectText(obj.userDetails.state);
    model.userStateName = this.utilserv.getObjectText(obj.userDetails.stateName);
    model.isuserState = model.userState.length <= 0 || model.userStateName.length <= 0 ? true : false;
    model.userCity = this.utilserv.getObjectText(obj.userDetails.city);
    model.isuserCity = model.userCity.length <= 0 ? true : false;
    model.useremail = this.utilserv.getObjectText(obj.userDetails.email);
    model.isuseremail = model.useremail.length <= 0 ? true : false;
    model.userAddress = this.utilserv.getObjectText(obj.userDetails.address);
    model.isuserAddress = model.userAddress.length <= 0 ? true : false;
    model.userZipcode = this.utilserv.getObjectText(obj.userDetails.zipcode);
    model.isuserZipcode = model.userZipcode.length <= 0 ? true : false;
    model.userOccupation = this.utilserv.getObjectText(obj.userDetails.occupation);

    model.isuserOccupation = model.userOccupation.length == 0 && validation.IsCustomerOccupationRequired == true ? true : false;
    model.userEmployer = this.utilserv.getObjectText(obj.userDetails.employess);
    model.isuserEmployer = model.userEmployer.length == 0 && validation.IsCustomerEmployerRequired == true ? true : false;

    model.userLastOrderNumber = obj.userDetails.LastOrderNumber;
    model.isuserLastOrderNumber = model.userLastOrderNumber.length <= 0 ? true : false;
    model.userloyaltyCardNumber = obj.userDetails.loyaltyCardNumber;
    model.isuserloyaltyCardNumber = model.userloyaltyCardNumber.length <= 0 ? true : false;

    // beneficiary
    model.beneficiaryId = this.utilserv.getObjectText(obj.beneficiaryDetails.BeneficiaryId);
    model.isBeneficiaryId = model.beneficiaryId.length <= 0 ? true : false;
    model.beneficiaryIdentificationType = this.utilserv.getObjectText(obj.beneficiaryDetails.IdentificationType);
    model.isbeneficiaryIdentificationType = model.beneficiaryIdentificationType.length <= 0 ? true : false;
    model.beneficiaryIdentificationNumber = this.utilserv.getObjectText(obj.beneficiaryDetails.IdentificationNumber);
    model.isbeneficiaryIdentificationNumber = model.beneficiaryIdentificationNumber.length <= 0 && validation.IsBeneficiaryIdentificationRequired ? true : false;
    model.beneficiaryEmailAddress = this.utilserv.getObjectText(obj.beneficiaryDetails.EmailAddress);
    model.isbeneficiaryEmailAddress = model.beneficiaryEmailAddress.length <= 0 ? true : false;
    model.beneficiaryAdditionalLastName = this.utilserv.getObjectText(obj.beneficiaryDetails.AdditionalLastName);
    model.isbeneficiaryAdditionalLastName = model.beneficiaryAdditionalLastName.length <= 0 && validation.isBeneficiaryLastName2Required ? true : false;
    model.beneficiaryFirstName = this.utilserv.getObjectText(obj.beneficiaryDetails.FirstName);
    model.isbeneficiaryFirstName = model.beneficiaryFirstName.length <= 0 ? true : false;
    model.beneficiaryMiddlename = this.utilserv.getObjectText(obj.beneficiaryDetails.MiddleName);

    model.beneficiaryLastName = this.utilserv.getObjectText(obj.beneficiaryDetails.LastName);
    model.isbeneficiaryLastName = model.beneficiaryLastName.length <= 0 ? true : false;
    model.beneficiaryNickName = this.utilserv.getObjectText(obj.beneficiaryDetails.NickName);
    model.isbeneficiaryNickName = model.beneficiaryNickName.length <= 0 ? true : false;
    model.beneficiaryPhone = this.utilserv.getObjectText(obj.beneficiaryDetails.Phone);
    model.isbeneficiaryPhone = model.beneficiaryPhone.length <= 0 && validation.IsBeneficiaryPhoneRequired ? true : false;
    model.beneficiaryCountry = this.utilserv.getObjectText(obj.beneficiaryDetails.Addresses.CountryCode);
    model.isbeneficiaryCountry = model.beneficiaryCountry.length <= 0 ? true : false;

    model.beneficiaryState = this.utilserv.getObjectText(obj.beneficiaryDetails.Addresses.StateCode);
    model.isbeneficiaryState = model.beneficiaryState.length <= 0 ? true : false;
    model.beneficiaryCity = this.utilserv.getObjectText(obj.beneficiaryDetails.Addresses.CityCode);
    model.isbeneficiaryCity = model.beneficiaryCity.length <= 0 ? true : false;
    model.beneficiaryAddress = this.utilserv.getObjectText(obj.beneficiaryDetails.Addresses.Address1);
    model.isbeneficiaryAddress = model.beneficiaryAddress.length <= 0 && validation.IsBeneficiaryAddressRequired ? true : false;
    model.beneficiaryZipcode = this.utilserv.getObjectText(obj.beneficiaryDetails.Addresses.ZipCode);
    model.isbeneficiaryZipcode = model.beneficiaryZipcode.length <= 0 && validation.IsBeneficiaryZipCodeRequired ? true : false;
    model.beneficiaryRelationship = this.utilserv.getObjectText(obj.beneficiaryDetails.Relationship);
    model.isbeneficiaryRelationship = model.beneficiaryRelationship.length <= 0 && validation.IsBeneficiaryRelationRequired ? true : false;
    model.reasonSendingMoney = this.utilserv.getObjectText(obj.additionalInfo.reasonSendingMoney);
    model.isreasonSendingMoney = validation.IsTransferReasonRequired ? true : false;
    model.fundSource = this.spanishConvert.removeDiacritics(this.utilserv.getObjectText(obj.additionalInfo.fundSource), true);
    model.isfundSource = validation.IsFundSourceRequired ? true : false;
    return model;
  }

  prepareEnvelopePayerDetails(PickupCenterRequest: any, userGioLocation: any) {
    this.userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      this.userGioLocation = data;
    });
    this.userGioLocation = userGioLocation;
    const envelope = {
      Amount: PickupCenterRequest.srcAmount,
      CityTo: PickupCenterRequest.CityTo,
      Count: PickupCenterRequest.RecordCount,
      CountryCodeFrom: PickupCenterRequest.CountryFrom,
      CountryCodeTo: PickupCenterRequest.CountryTo,
      CurrencyCodeFrom: PickupCenterRequest.CurrencyFrom,
      CurrencyCodeTo: PickupCenterRequest.CountrySupportedCurrencyCodesTo,
      DeliveryMethod: PickupCenterRequest.DeliveryMethod,
      EndUserLatitude: this.userGioLocation.latitude,
      EndUserLongitude: this.userGioLocation.longitude,
      FilterBy: {
        FilterByID: PickupCenterRequest.FilterBy,
        FilterByName: PickupCenterRequest.FilterByText
      },
      Index: PickupCenterRequest.Index,
      LanguageCode: sessionStorage.langCode,
      LocationId: PickupCenterRequest.LocationId,
      ProgramId: PickupCenterRequest.ProgramId,
      SearchForPayer: PickupCenterRequest.SearchForPayer,
      Session: {
        T1: sessionStorage.T1,
        T2: sessionStorage.T2
      },
      SortBy: {
        SortByID: PickupCenterRequest.SortBy,
        SortByName: PickupCenterRequest.SortByText
      },
      StateCodeFrom: PickupCenterRequest.StateFrom,
      StateCodeTo: PickupCenterRequest.StateTo
    };
    return JSON.stringify(envelope); 
  }

  getBranchDetails(searchParams: AgentDetails) {
    return this.utilserv.restPost(this.branchDetailsEnvelope(searchParams), AppSettings.getBranchesService + '/GetBranches');
  }
  branchDetailsEnvelope(searchParams: any) {
      let UserData = JSON.parse(
        this.utilserv.AESDecrypt(sessionStorage.UserData) 
      );

      // Validación manual paso a paso
      let stateCode = null;

      if (
          UserData && 
          UserData.Envelope && 
          UserData.Envelope.Body && 
          UserData.Envelope.Body.CustomerInfoResponse && 
          UserData.Envelope.Body.CustomerInfoResponse.Address && 
          UserData.Envelope.Body.CustomerInfoResponse.Address.StateCode && 
          UserData.Envelope.Body.CustomerInfoResponse.Address.StateCode.__text
      ) {
          stateCode = UserData.Envelope.Body.CustomerInfoResponse.Address.StateCode.__text;
      } else {
          stateCode = "";
          console.error("Alguna propiedad en la cadena es undefined o null");
      }
    let envelope = `{
                          "Amount":"${searchParams.Amount == 0 ? '' : searchParams.Amount}",
                          "ProgramId":${searchParams.ProgramId},
                          "CountryCodeFrom":"${searchParams.CountryFrom}",
                          "CountryCodeTo":"${searchParams.CountryTo}",
                          "CurrencyCodeFrom":"${searchParams.CurrencyFrom}",
                          "CurrencyCodeTo":"${searchParams.CurrencyTo}",
                          "CountrySupportedCurrencyCodesTo":"${searchParams.CountrySupportedCurrencyCodesTo}",
                          "StateCodeFrom": "${stateCode}",
                          "StateCodeTo":"${searchParams.LocationId == 0 ? searchParams.StateTo : ''}",
                          "CityTo":"${searchParams.LocationId == 0 ? searchParams.CityTo : ''}",
                          "SearchForPayer":"${searchParams.SearchForPayer}",
                          "LocationId":"${searchParams.LocationId}",
                          "DeliveryMethod":${searchParams.DeliveryMethod},`;
    if (searchParams.FilterBy != 0) {
      envelope += `"FilterBy": {
                            "FilterByID": "${searchParams.FilterBy}",
                            "FilterByName": ""
                          },`;
    }
    if (searchParams.SortBy != 0) {
      envelope += `"SortBy": {
                            "SortByID": "${searchParams.SortBy}",
                            "SortByName": ""
                          },`;
    }
    envelope += `"LanguageCode":"${sessionStorage.langCode}",
                          "Session":{
                                      "T1":"${sessionStorage.T1}",
                                      "T2":"${sessionStorage.T2}"
                                     },
                          "PayingAgentId":"${searchParams.PayingAgentId}",
                          "AccountType":null
                          }`;
    return envelope;
  }

  getPayerLogo(searchParams) {
    return this.utilserv.restPost(this.agentLogoEnvelope(searchParams), AppSettings.AgentManagementService + '/GetPayingAgentImage',false);
  }
  agentLogoEnvelope(searchParams: any) {
    const envelope = {
      PayingAgentId: this.utilserv.getObjectText(searchParams.PayingAgentId),
      Device: 2,
      LanguageCode: sessionStorage.langCode,
      Session: { T2: sessionStorage.T2 }
    };
    return JSON.stringify(envelope);
  }

  getBankLogo(searchParams) {
    return this.utilserv.restPost(this.bankLogoEnvelope(searchParams), AppSettings.AgentManagementService + '/GetBankImage',false);
  }
  bankLogoEnvelope(searchParams: any) {
    const envelope = {
      BankName: searchParams.BankName,
      BankId: searchParams.BankId,
      // "PayingAgentId": searchParams.PayingAgentIdForImage,
      LanguageCode: sessionStorage.langCode,
      Session: { T2: sessionStorage.T2 }
    };
    return JSON.stringify(envelope);
  }

  getBranchImage(searchParams) {
    return this.utilserv.restPost(this.branchImageEnvelope(searchParams), AppSettings.getBranchesService + '/GetBranchImage',false);
  }
  branchImageEnvelope(searchParams: any) {
    const envelope = {
      PayingAgentId: this.utilserv.getObjectText(searchParams.PayingAgentId),
      LocationId: this.utilserv.getObjectText(searchParams.LocationId),
      Session: {
        T2: sessionStorage.T2
      }
    };
    return JSON.stringify(envelope);
  }
  getBeneficiaryList() {
    return this.utilserv.soapPostwithoutAction(this.getBeneficiaryEnvelope(), AppSettings.BeneficiaryService);
  }
  getBeneficiaryEnvelope() {
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
    <s:Header>
    <a:Action s:mustUnderstand="1">http://tempuri.org/IMicroServiceBeneficiary/GetBeneficiaries</a:Action>
    <a:MessageID>urn:uuid:d8e9e937-e8fa-498c-b770-0481d6b98976</a:MessageID>
    <a:ReplyTo>
    <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
    </a:ReplyTo>
    </s:Header>
    <s:Body>
    <CustomerInfoRequest xmlns="http://tempuri.org/">
    <LanguageCode>${sessionStorage.langCode}</LanguageCode>
    <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
    <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
    <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
    </Session>
    </CustomerInfoRequest>
    </s:Body>
    </s:Envelope>`;
    return envelope;
  }

  addBeneficiary(beneficiaryInfo: BeneficiaryDetails) {
    return this.utilserv.soapPostwithoutAction(this.AddBeneficiaryEnvelope(beneficiaryInfo), AppSettings.BeneficiaryService);
  }
  AddBeneficiaryEnvelope(beneficiaryInfo: BeneficiaryDetails) {
    let envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
    <s:Header>
    <a:Action s:mustUnderstand="1">http://tempuri.org/IMicroServiceBeneficiary/AddBeneficiary</a:Action>
    <a:MessageID>urn:uuid:ed2aeb34-3b58-4991-b03a-e147ff84b677</a:MessageID>
    <a:ReplyTo>
    <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
    </a:ReplyTo>
    </s:Header>
    <s:Body>
    <BeneficiaryDetail xmlns="http://tempuri.org/">
       <AdditionalLastName>${this.spanishConvert.removeDiacritics(this.utilserv.isNull(beneficiaryInfo.AdditionalLastName), true)}</AdditionalLastName>
       <Addresses xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
           <d4p1:Address1>${this.spanishConvert.removeDiacritics(this.utilserv.isNull(beneficiaryInfo.address), true)}</d4p1:Address1>
           <d4p1:CityCode>${this.utilserv.isNull(beneficiaryInfo.city)}</d4p1:CityCode>
           <d4p1:CountryCode>${this.utilserv.isNull(beneficiaryInfo.country)}</d4p1:CountryCode>
           <d4p1:StateCode>${this.utilserv.isNull(beneficiaryInfo.state)}</d4p1:StateCode>
           <d4p1:ZipCode>${this.utilserv.isNull(beneficiaryInfo.zipCode)}</d4p1:ZipCode>
       </Addresses>
       <BeneficiaryId>${beneficiaryInfo.BeneficiaryId.toString()}</BeneficiaryId>
       <Checksum></Checksum>
       <EmailAddress>${this.utilserv.isNull(beneficiaryInfo.EmailAddress)}</EmailAddress>
       <FirstName>${this.spanishConvert.removeDiacritics(this.utilserv.isNull(beneficiaryInfo.FirstName), true)}</FirstName>
       <IdentificationNumber></IdentificationNumber>
       <IdentificationType></IdentificationType>
       <IsBeneficiaryUpdated>true</IsBeneficiaryUpdated>
       <LanguageCode>${this.utilserv.isNull(sessionStorage.langCode)}</LanguageCode>
       <LastName>${this.spanishConvert.removeDiacritics(this.utilserv.isNull(beneficiaryInfo.LastName), true)}</LastName>
       <MiddleName></MiddleName>
       <NickName>${this.spanishConvert.removeDiacritics(this.utilserv.isNull(beneficiaryInfo.NickName), true)}</NickName>
       <Phone>${this.utilserv.isNull(beneficiaryInfo.Phone)}</Phone>
       <Relationship></Relationship>
       <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
           <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
           <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
       </Session>
    </BeneficiaryDetail>
    </s:Body>
    </s:Envelope>`;
    return envelope;
  }

  saveMissingInfo(missingInfo: any, IsBeneficiaryUpdated: boolean = true) {
    return this.utilserv.soapPostwithoutAction(this.MissingInformationEnvelope(missingInfo, IsBeneficiaryUpdated), AppSettings.ICEUserMgmtService);
  }
  // create SOAP Request For missing informaton
  MissingInformationEnvelope(missingInfo, IsBeneficiaryUpdated) {
    let SOAPMessage = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
      <s:Header>
        <a:Action s:mustUnderstand="1">http://tempuri.org/IICEUserMgmt/SaveMissingInformation</a:Action>
        <a:MessageID>urn:uuid:132b9456-91e0-4f91-ac02-7a389470f656</a:MessageID>
        <a:ReplyTo>
          <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
        </a:ReplyTo>
      </s:Header>
      <s:Body>
     <MissingInformation xmlns="http://tempuri.org/">
    <BeneficiaryAdditionalInfo xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:AdditionalLastName>${this.spanishConvert.removeDiacritics(missingInfo.beneficiaryAdditionalLastName.trim(), true)}</d4p1:AdditionalLastName>
            <d4p1:Addresses>
              <d4p1:Address1>${this.spanishConvert.removeDiacritics(missingInfo.beneficiaryAddress.trim(), true)}</d4p1:Address1>
              <d4p1:CityCode>${missingInfo.beneficiaryCity}</d4p1:CityCode>
              <d4p1:CountryCode>${missingInfo.beneficiaryCountry}</d4p1:CountryCode>
              <d4p1:StateCode>${missingInfo.beneficiaryState}</d4p1:StateCode>
              <d4p1:ZipCode>${missingInfo.beneficiaryZipcode}</d4p1:ZipCode>
            </d4p1:Addresses>
            <d4p1:BeneficiaryId>${missingInfo.beneficiaryId}</d4p1:BeneficiaryId>
            <d4p1:Checksum></d4p1:Checksum>
            <d4p1:EmailAddress>${missingInfo.beneficiaryEmailAddress}</d4p1:EmailAddress>
            <d4p1:FirstName>${this.spanishConvert.removeDiacritics(missingInfo.beneficiaryFirstName.trim(), true)}</d4p1:FirstName>
            <d4p1:IdentificationNumber>${missingInfo.beneficiaryIdentificationNumber}</d4p1:IdentificationNumber>
            <d4p1:IdentificationType>${missingInfo.beneficiaryIdentificationType}</d4p1:IdentificationType>
            <d4p1:IsBeneficiaryUpdated>${IsBeneficiaryUpdated}</d4p1:IsBeneficiaryUpdated>
            <d4p1:LastName>${this.spanishConvert.removeDiacritics(missingInfo.beneficiaryLastName.trim(), true)}</d4p1:LastName>
            <d4p1:MiddleName>${this.spanishConvert.removeDiacritics(missingInfo.beneficiaryMiddlename.trim(), true)}</d4p1:MiddleName>
            <d4p1:NickName>${this.spanishConvert.removeDiacritics(missingInfo.beneficiaryNickName.trim(), true)}</d4p1:NickName>
            <d4p1:Phone>${missingInfo.beneficiaryPhone}</d4p1:Phone>
            <d4p1:Relationship>${missingInfo.beneficiaryRelationship}</d4p1:Relationship>
    </BeneficiaryAdditionalInfo>

    <CustomerAdditionalInfo xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
           <d4p1:KeyUID></d4p1:KeyUID>
            <d4p1:LanguageCode>${this.utilserv.isNull(sessionStorage.langCode)}</d4p1:LanguageCode>
            <d4p1:Session i:nil="true" />
            <d4p1:AdditionalLastName>${missingInfo.useradditionalLastName}</d4p1:AdditionalLastName>
            <d4p1:Address>
              <d4p1:Address1>${this.spanishConvert.removeDiacritics(missingInfo.userAddress.trim(), true)}</d4p1:Address1>
              <d4p1:CityCode>${missingInfo.userCity}</d4p1:CityCode>
              <d4p1:CountryCode>${missingInfo.userCountry}</d4p1:CountryCode>
              <d4p1:StateCode>${missingInfo.userState}</d4p1:StateCode>
              <d4p1:StateName>${missingInfo.userStateName}</d4p1:StateName>
              <d4p1:ZipCode>${missingInfo.userZipcode}</d4p1:ZipCode>
            </d4p1:Address>
            <d4p1:Checksum></d4p1:Checksum>
            <d4p1:CustomerEmail>${missingInfo.useremail}</d4p1:CustomerEmail>
            <d4p1:CustomerEmployer>${this.spanishConvert.removeDiacritics(missingInfo.userEmployer.trim(), true)}</d4p1:CustomerEmployer>
            <d4p1:CustomerOccupation>${missingInfo.userOccupation}</d4p1:CustomerOccupation>
            <d4p1:CustomerPwd></d4p1:CustomerPwd>
            <d4p1:DOB>${missingInfo.userDOB}</d4p1:DOB>
            <d4p1:FirstName>${this.spanishConvert.removeDiacritics(missingInfo.userfirstName.trim(), true)}</d4p1:FirstName>
            <d4p1:LastName>${this.spanishConvert.removeDiacritics(missingInfo.userlastName.trim(), true)}</d4p1:LastName>
            <d4p1:LastOrderNumber>${missingInfo.userLastOrderNumber}</d4p1:LastOrderNumber>
            <d4p1:LoyaltyCardNumber>${missingInfo.userloyaltyCardNumber}</d4p1:LoyaltyCardNumber>
            <d4p1:MiddleName>${this.spanishConvert.removeDiacritics(missingInfo.usermiddleName.trim(), true)}</d4p1:MiddleName>
            <d4p1:MobileNumber>${missingInfo.usermobile}</d4p1:MobileNumber>
            <d4p1:OTPValue></d4p1:OTPValue>
            <d4p1:PreferCountryCode>${missingInfo.usercountryPreference}</d4p1:PreferCountryCode>
            <d4p1:ReceivingAgentId></d4p1:ReceivingAgentId>
            <d4p1:RegistartionCode></d4p1:RegistartionCode>
            <d4p1:UserID>${missingInfo.userUserID}</d4p1:UserID>
            <d4p1:UserVerifiedBy></d4p1:UserVerifiedBy>
          </CustomerAdditionalInfo>
          <KeyUID></KeyUID>
          <LanguageCode>${sessionStorage.langCode}</LanguageCode>
          <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
            <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
          </Session>
        </MissingInformation>
      </s:Body>
    </s:Envelope>`;
    return SOAPMessage;
  }

  // get pay at store list
  loadStoresInMap(IsPayatstore: boolean = true, userGioLocation) {
    return this.utilserv.soapPostwithoutAction(this.StoresInMapEnvelope(IsPayatstore, userGioLocation), AppSettings.ICEStoreLocatorService);
  }

  StoresInMapEnvelope(IsPayatstore, userGioLocation) {
    this.userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      this.userGioLocation = data;
    });
    if (userGioLocation != undefined) {
      this.userGioLocation = userGioLocation;
    }
    let envelope = ` <s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                        <s:Header>
                          <a:Action s:mustUnderstand="1">http://tempuri.org/IStoreLocator/GetStoreLocators</a:Action>
                          <a:MessageID>urn:uuid:0953e852-0275-47f1-9ab0-659b1346e945</a:MessageID>
                          <a:ReplyTo>
                            <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                          </a:ReplyTo>
                        </s:Header>
                        <s:Body>
                          <AgentStoreRequest xmlns="http://tempuri.org/">
                            <IsPayatstore>${IsPayatstore}</IsPayatstore>
                            <LanguageCode>en</LanguageCode>
                            <Latitude>${this.userGioLocation.latitude}</Latitude>
                            <Longitude>${this.userGioLocation.longitude}</Longitude>
                            <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.DataContract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                              <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                              <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                            </Session>
                          </AgentStoreRequest>
                        </s:Body>
                      </s:Envelope>`;
    return envelope;
  }
  // get pay at store list
  getstoreimage(storeid: string) {
    return this.utilserv.soapPostwithoutAction(this.getstoreimageenvelope(storeid), AppSettings.ICEStoreLocatorService);
  }

  getstoreimageenvelope(storeid) {
    let envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
          <s:Header>
            <a:Action s:mustUnderstand="1">http://tempuri.org/IStoreLocator/GetStoreImage</a:Action>
            <a:MessageID>urn:uuid:5c384545-4229-4556-afae-3a651d845f35</a:MessageID>
            <a:ReplyTo>
              <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
            </a:ReplyTo>
          </s:Header>
          <s:Body>
            <AgentStoreImageRequest xmlns="http://tempuri.org/">
              <LanguageCode>${sessionStorage.langCode}</LanguageCode>
              <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.DataContract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                  <d4p1:T1 i:nil="true" />
                  <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
              </Session>
              <StoreID>${storeid}</StoreID>
            </AgentStoreImageRequest>
          </s:Body>
          </s:Envelope>
          `;
    return envelope;
  }

  pay(reqObject: SendMoneyDetail) {
    return this.utilserv.soapPostwithoutAction(this.payEnvelope(reqObject), AppSettings.OrderProcessingService);
  }
  payEnvelope(reqObject: SendMoneyDetail) {
    this.userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      this.userGioLocation = data;
    });
    let envelope =
      '<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope"> \n' +
      '<s:Header> \n' +
      '<a:Action s:mustUnderstand="1">http://tempuri.org/IOrderProcessingService/DoPayment</a:Action> \n' +
      '<a:MessageID>urn:uuid:1565225c-b03f-41b5-abc3-2a1c940080d6</a:MessageID> \n' +
      '<a:ReplyTo> \n' +
      '<a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address> \n' +
      '</a:ReplyTo> \n' +
      '</s:Header> \n' +
      '<s:Body> \n' +
      '<PaymentRequest xmlns="http://tempuri.org/"> \n' +
      '<Currency>' +
      reqObject.agentDetails.CurrencyFrom +
      '</Currency> \n' +
      '<EndUserLatitude>' +
      this.userGioLocation.latitude +
      '</EndUserLatitude> \n' +
      '<EndUserLongitude>' +
      this.userGioLocation.longitude +
      '</EndUserLongitude> \n' +
      '<EndUserIP>' +
      sessionStorage.EndUserIP +
      '</EndUserIP> \n' +
      `<EntryType>${AppSettings.Platform}</EntryType> \n` +
      `<FundingId>${reqObject.paymentDetails.paymentType == 30 ? reqObject.paymentDetails.fundingId : 0}</FundingId> \n` +
      '<Items xmlns:d4p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays" xmlns:i="http://www.w3.org/2001/XMLSchema-instance"> \n';

    reqObject.shopingCartList.forEach(element => {
      envelope += '<d4p1:int>' + element.itemId + '</d4p1:int> \n';
    });

    envelope +=
      '</Items> \n' +
      '<LanguageCode>' +
      sessionStorage.langCode +
      '</LanguageCode> \n' +
      '<Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap" xmlns:i="http://www.w3.org/2001/XMLSchema-instance"> \n' +
      '<d4p1:T1>' +
      sessionStorage.T1 +
      '</d4p1:T1> \n' +
      '<d4p1:T2>' +
      sessionStorage.T2 +
      '</d4p1:T2> \n' +
      '</Session> \n' +
      '<TotalAmount>' +
      // MarketingBalance or shate credit available
      (reqObject.paymentDetails.totalAmount > reqObject.userDetails.MarketingBalance ? reqObject.paymentDetails.totalAmount - reqObject.userDetails.MarketingBalance : 0) +
      '</TotalAmount> \n' +
      '</PaymentRequest> \n' +
      '</s:Body> \n' +
      '</s:Envelope>';
    return envelope;
  }

  documentRequiredCheck() {
    return this.utilserv.soapPostwithoutAction(this.documentRequiredCheckEnvelope(), AppSettings.ICEDocumentMgmt);
  }

  documentRequiredCheckEnvelope() {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    this.userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      this.userGioLocation = data;
    });
    let envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
      <s:Header>
      <a:Action s:mustUnderstand="1">http://tempuri.org/IICEDocumentMgmt/GetDocumentRequired</a:Action>
      <a:MessageID>urn:uuid:32817d04-4d63-448a-9402-398fdc5cb771</a:MessageID>
      <a:ReplyTo>
      <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
      </a:ReplyTo>
      </s:Header>
      <s:Body>
      <RequestBase xmlns="http://tempuri.org/">
      <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
        <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
        <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
        <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
        <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
        <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
        <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
        <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
        <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
        <d4p1:Latitude>${this.userGioLocation.latitude}</d4p1:Latitude>
        <d4p1:Longitude>${this.userGioLocation.longitude}</d4p1:Longitude>
        <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
      </DeviceDetails>
      <LanguageCode>${sessionStorage.langCode}</LanguageCode>
      <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.DocumentManagement.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
      <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
      <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
      </Session>
      </RequestBase>
      </s:Body>
      </s:Envelope>`;
    return envelope;
  }

  // loadPickupTypeText(type) {
  //   let classVal;
  //   switch (parseInt(type, 0)) {
  //     case PickupType.atmDeposit: {
  //       classVal = this.translate.instant('PickupType_btnAtmDeposit');
  //       break;
  //     }
  //     case PickupType.bankDeposit: {
  //       classVal = this.translate.instant('PickupType_btnBankDeposit');
  //       break;
  //     }
  //     case PickupType.homeDelivery: {
  //       classVal = this.translate.instant('PickupType_btnHomeDelivery');
  //       break;
  //     }
  //     case PickupType.officePickup: {
  //       classVal = this.translate.instant('PickupType_btnOfficePickup');
  //       break;
  //     }
  //   }
  //   return classVal;
  // }
  initializestore(obj) {
    const storeDetails: StoreDetails = new StoreDetails();
    storeDetails.storeId = this.utilserv.getObjectText(obj.StoreID);
    storeDetails.storeaddress.Address1 = this.utilserv.getObjectText(obj.Address.Address1);
    storeDetails.storeaddress.CityCode = this.utilserv.getObjectText(obj.Address.City);
    storeDetails.storeaddress.CountryCode = this.utilserv.getObjectText(obj.Address.CountryCode);
    storeDetails.storeaddress.Latitude = this.utilserv.getObjectText(obj.Address.Latitude);
    storeDetails.storeaddress.Longitude = this.utilserv.getObjectText(obj.Address.Longitude);
    storeDetails.storeaddress.StateCode = this.utilserv.getObjectText(obj.Address.StateCode);
    storeDetails.storeaddress.ZipCode = this.utilserv.getObjectText(obj.Address.ZipCode);
    storeDetails.storeName = this.utilserv.getObjectText(obj.Name);
    storeDetails.storenotesSection = this.utilserv.getObjectText(obj.Notes);
    storeDetails.storespecialInstructionSection = this.utilserv.getObjectText(obj.SpecialInstructions);
    storeDetails.storeOpeningTime = this.utilserv.getObjectText(obj.TimeForThisWeek);
    storeDetails.storedirections = this.utilserv.getObjectText(obj.Directions);
    storeDetails.storedistance = this.utilserv.getObjectText(obj.Distance);
    storeDetails.storemail = this.utilserv.getObjectText(obj.Email);
    storeDetails.storeLimitations = this.utilserv.getObjectText(obj.Limitations);
    storeDetails.storePhoneNumber = this.utilserv.getObjectText(obj.PhoneNumber);
    storeDetails.storeRestrictions = this.utilserv.getObjectText(obj.Restrictions);
    storeDetails.storeScheduleThisWeekThisWeek = this.utilserv.getObjectText(obj.TimeForThisWeek);

    this.getstoreimage(this.utilserv.getObjectText(storeDetails.storeId)).subscribe(
      data => {
        if (data.Envelope.Body.AgentStoreImageResponse.StatusCode == 20001) {
          return false;
        }
        if (
          data.Envelope.Body.AgentStoreImageResponse.StatusCode == 1000 ||
          data.Envelope.Body.AgentStoreImageResponse.StatusCode == 10021 // Image not founde
        ) {
          storeDetails.storeimageurl = data.Envelope.Body.AgentStoreImageResponse.StoreImageData;
        }
      },
      error => {
        //console.log('Unable to fetch Store Image' + error);
      }
    );
  }
  getDisclaimerDetails() {
    return this.utilserv.restGet(AppSettings.ICEMasterService + '/GetDisclaimer', true);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/sendmoneyservice/sendmoneyservice.ts